export default __webpack_public_path__ + "static/media/icon_productsdb.068ec946.svg";